import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-admission-status',
  imports: [SharedModule],
  templateUrl: './admission-status.component.html',
  styleUrl: './admission-status.component.scss'
})
export class AdmissionStatusComponent {

  @Input() currentStatus: string = '';

  statuses = [ "Under Review", "Approved", "Rejected", "Waitlisted"];

  ngOnInit() {
    // Initialize any necessary data or state here
    console.log('Current Status:', this.currentStatus);
  }

  getStatusClass(status: string): string {
    const currentIndex = this.statuses.indexOf(this.currentStatus);
    const statusIndex = this.statuses.indexOf(status);

    if (statusIndex < currentIndex) {
      return 'completed'; // Previous steps (dark)
    } else if (statusIndex === currentIndex) {
      return 'current'; // Current step (yellow)
    } else {
      return 'upcoming'; // Upcoming steps (light)
    }
  }
}
